// Vendor
import { ElementRef } from '@angular/core';
// Utils / Constants / Enums
import { IS_PANEL_SIDEBAR_HIDDEN, IS_PANEL_SIDEBAR_SHOWN } from 'NewAngular/constants/list-page.constants';
// Services
import { SearchAllStateService } from 'SearchApp/ts/apps/search-all-app/services/search-all-state.service';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "SearchApp/ts/apps/search-all-app/services/search-all-state.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../search-all-categories/search-all-categories.component";
import * as i7 from "../search-all-input/search-all-input.component";
import * as i8 from "../search-all-table/search-all-table.component";
function SearchAllPageComponent_Conditional_30_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵlistener("click", function SearchAllPageComponent_Conditional_30_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleFilterSidebar(true)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 32);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Filter list");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-filter");
} }
/**
 *
 * SearchAllPageComponent.
 *
 * This component is the page that holds the components for the search result lists, search bar and
 * filters by category.
 */
export class SearchAllPageComponent {
    constructor(accountsService, eltRef, searchAllAppState) {
        this.accountsService = accountsService;
        this.eltRef = eltRef;
        this.searchAllAppState = searchAllAppState;
        this.filterSidebarShownClass = IS_PANEL_SIDEBAR_SHOWN;
        this.IS_PANEL_SIDEBAR_HIDDEN = IS_PANEL_SIDEBAR_HIDDEN;
        this.searchAllAppState.initAppState();
        const initialFilterSidebarShown = eltRef.nativeElement.getAttribute('filterSidebarShown') === 'True';
        this.filterSidebarShownClass = initialFilterSidebarShown ? IS_PANEL_SIDEBAR_SHOWN : IS_PANEL_SIDEBAR_HIDDEN;
    }
    toggleFilterSidebar(isOpen) {
        this.filterSidebarShownClass = isOpen ? IS_PANEL_SIDEBAR_SHOWN : IS_PANEL_SIDEBAR_HIDDEN;
        const params = { search_list_show_filter_sidebar: isOpen ? 'True' : 'False' };
        this.accountsService.putUserPreferences(params).subscribe();
    }
}
SearchAllPageComponent.ɵfac = function SearchAllPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SearchAllPageComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.SearchAllStateService)); };
SearchAllPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SearchAllPageComponent, selectors: [["ycn-search-all-page"]], standalone: false, decls: 39, vars: 3, consts: [[1, "container"], [1, "page-header", "row"], [1, "page-title", "col-auto"], [1, "page-name"], [1, "page-name-text"], [1, "page-header-actions"], [1, "page-body", "panel-sidebar-220", "panel", "panel-with-sidebar", 3, "ngClass"], [1, "panel-wrap", "row"], [1, "panel-sidebar-wrap"], [1, "panel-sidebar", "panel-sidebar-scroll"], [1, "panel-sidebar-section", "panel-sidebar-header"], [1, "panel-sidebar-section-header"], [1, "panel-sidebar-section-title"], ["ycnIcon", "", "name", "icon-filter", 1, "icon-filter", "mr-1"], [1, "text-uppercase"], ["ycnTooltip", "", "tooltipPlacement", "bottom", "tooltipTitle", "Close", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "panel-sidebar-toggler", "panel-sidebar-toggler-close", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "panel-sidebar-section"], [1, "panel-sidebar-section", "panel-sidebar-footer"], [1, "panel-sidebar-section-body"], [1, "form-row"], ["href", "#", 1, "text-underline"], [1, "panel-content-wrap"], [1, "panel-content"], [1, "panel-content-header", "border-b", "border-color-gray-90"], ["href", "javascript:void(0)", 1, "btn", "btn-secondary", "panel-sidebar-toggler", "panel-sidebar-toggler-open"], [1, "panel-subtitle"], [1, "panel-actions"], [1, "panel-action"], [1, "overflow-wrap", "flex-auto"], [1, "overflow-auto"], ["href", "javascript:void(0)", 1, "btn", "btn-secondary", "panel-sidebar-toggler", "panel-sidebar-toggler-open", 3, "click"], ["ycnIcon", "", 1, "icon-filter", 3, "name"]], template: function SearchAllPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "span", 4);
        i0.ɵɵtext(5, "Search Results");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(6, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "div", 8)(10, "div", 9)(11, "section", 10)(12, "div", 11)(13, "div", 12);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(14, "svg", 13);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(15, "span", 14);
        i0.ɵɵtext(16, "Filter");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(17, "button", 15);
        i0.ɵɵlistener("click", function SearchAllPageComponent_Template_button_click_17_listener() { return ctx.toggleFilterSidebar(false); });
        i0.ɵɵelementStart(18, "span");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(19, "svg", 16);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(20, "section", 17);
        i0.ɵɵelement(21, "ycn-search-all-categories");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "section", 18)(23, "div", 19)(24, "div", 20)(25, "a", 21);
        i0.ɵɵtext(26, "Clear filters");
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelementStart(27, "div", 22)(28, "div", 23)(29, "div", 24);
        i0.ɵɵtemplate(30, SearchAllPageComponent_Conditional_30_Template, 4, 1, "a", 25);
        i0.ɵɵelementStart(31, "div", 26);
        i0.ɵɵtext(32, "Search Results");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 27)(34, "div", 28);
        i0.ɵɵelement(35, "ycn-search-all-input");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(36, "div", 29)(37, "div", 30);
        i0.ɵɵelement(38, "ycn-search-all-table");
        i0.ɵɵelementEnd()()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngClass", ctx.filterSidebarShownClass);
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("name", "icon-close");
        i0.ɵɵadvance(11);
        i0.ɵɵconditional(ctx.filterSidebarShownClass === ctx.IS_PANEL_SIDEBAR_HIDDEN ? 30 : -1);
    } }, dependencies: [i3.NgClass, i4.TooltipDirective, i5.IconDirective, i6.SearchAllCategoriesComponent, i7.SearchAllInputComponent, i8.SearchAllTableComponent], encapsulation: 2 });
